import React from 'react';
import '../../styles/Button.css';

const Button = ({ children, variant = 'primary', size = 'normal', className = '', type = 'button', onClick, disabled = false, ariaLabel }) => {
	const buttonClass = `btn btn-${variant} ${size === 'small' ? 'btn-small' : ''} ${className}`;
	return (
		<button
			type={type}
			className={buttonClass}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
		>
			{children}
		</button>
	);
};

export default Button;